import Concierge from './AI Concierge.svg';
import Directories from './Directory.svg';
import DoorAccess from './Digital Keys.svg';
import EventsSchedule from './Calendar.svg';
import Events from './Events.svg';
import ExperienceSelector from './Experience Selector.svg';
import InteractiveMap from './Interactive Map.svg';
import MessageInbox from './Messages.svg';
import NewsWidget from './News & Announcements.svg';
import RealTimeBlueDot from './Real-Time Bluedot Wayfinding.svg';
import Resources from './Resources.svg';
import SocialLinks from './Social Links.svg';

const Hospitality = { 
    "Concierge": <img src={Concierge} style={{alignSelf: 'center'}} />,
    "Directories": <img src={Directories}  style={{alignSelf: 'center'}} />,
    "DoorAccess": <img src={DoorAccess}  style={{alignSelf: 'center'}} />, 
    "EventsSchedule": <img src={EventsSchedule} style={{alignSelf: 'center'}} />, 
    "Events": <img src={Events} style={{alignSelf: 'center'}} />, 
    "ExperienceSelector" : <img src={ExperienceSelector} style={{alignSelf: 'center'}} />, 
    "InteractiveMap": <img src={InteractiveMap} style={{alignSelf: 'center'}} />, 
    "MessageInbox": <img src={MessageInbox} style={{alignSelf: 'center'}} />, 
    "NewsWidget": <img src={NewsWidget} style={{alignSelf: 'center'}} />, 
    "RealTimeBlueDot": <img src={RealTimeBlueDot} style={{alignSelf: 'center'}} />, 
    "Resources": <img src={Resources} style={{alignSelf: 'center'}} />, 
    "SocialLinks": <img src={SocialLinks} style={{alignSelf: 'center'}} />
};

export default Hospitality;